<template>
  <!-- 资金支付过程台账 -->
  <div class="contain wageLedger" style="padding:1vh;width:100%;height:100%;">
    <!-- <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>施工管理</el-breadcrumb-item>
            <el-breadcrumb-item>计划进度产值</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row> -->
    <div class="box" style="overflow: auto;">
      <div class="build-bar" style="justify-content: space-between;height:10vh;width:100%;">
        <div style="display:flex;align-items:center;width: 16vw;flex-wrap:wrap;">
            <p style="display: flex;align-items: center;margin-right:1vw;width:100%;height: 4vh;">项目进度计划表</p>
            <p style="display: flex;align-items: center;margin-right:1vw;width:100%;height: 4vh;">计划总产值：<span v-if="isTotal">{{totalValue_view}}</span><el-input v-model="total" v-else style="width:8vw;margin-right:0.5vw;"></el-input> 万</p>
        </div>
        <div style="display:flex;align-items:center;width:calc(100% - 16vw);flex-wrap:wrap;justify-content: space-around;flex-direction: column;">
          <div style="width: 70%;text-align: left;"> 合同工期：{{info.allDay}}天</div>
          <div style="width: 70%;display:flex;align-items:center;justify-content: space-between;"> 
            <span>实际产值进度</span>
            <div style="width: 80%;">
              <el-progress :text-inside="true"   :stroke-width="32" :percentage="info.setmentProgress"></el-progress>
            </div>
            
          </div>
        </div>
        <!-- <div style="display:flex;justify-content: space-between;align-items:center;width:30%">
            <el-date-picker
                v-model="year"
                @change="doFilter"
                type="year"
                value-format="yyyy"
                placeholder="选择年"
                style="margin:auto;width:130px;font-size:12px"
            ></el-date-picker>
        </div> -->
        <!-- <el-button v-if="totalValue_view" type="success" icon="el-icon-plus" @click="addQin">添加</el-button> -->
      </div>
      <div class="box-content">
        <el-table :data="listData" border stripe style="width: 100%;">
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column label="序号" width="100" type="index">
            <el-table-column prop="index" label="姓名" width="100">
              <template slot="header">
                <img src="../../assets/image/coladd.png" @click="addQin" style="width:3vh;height:3vh;cursor: pointer;" />
              </template>
              <template slot-scope="scope">
                <span>{{ scope.row.index }}</span>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="年月">
            <template slot-scope="scope">
              <span v-if="scope.row.isSet && listData.length<2">
                <el-date-picker
                  v-model="master.months"
                  type="month"
                  @change="checkMonth"
                  value-format="yyyy-MM"
                  placeholder="选择月">
                </el-date-picker>
              </span>
              <span v-else>{{ scope.row.months }}</span>
            </template>
          </el-table-column>
          <el-table-column label="完成总产值占比">
            <template slot-scope="scope">
              <span v-if="scope.row.isSet">
                <el-input-number v-model="master.completePercentage" @change="proportionFun(scope.row)" :precision="2" :step="1" :min="scope.row.minPer" :max="100" placeholder="完成占比"></el-input-number>%
              </span>
              <span v-else>{{ scope.row.completePercentage }} %</span>
            </template>
          </el-table-column>
          <el-table-column label="产值(万元)">
            <template slot-scope="scope">
              <span>{{ scope.row.monthPay }}</span>
            </template>
          </el-table-column>
          <el-table-column label="关键节点">
            <template slot-scope="scope">
              <div style="width:100%;height:3vh;" v-for="(item,index) in scope.row.nodeList" :key="index">
                <p v-if="item.parentNodeName">{{item.parentNodeName}} <span v-if="item.nodeName && ''!=item.nodeName">- {{item.nodeName}}</span></p>
                <p v-else>{{item.nodeName}}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="完成日期">
            <template slot-scope="scope">
              <div style="width:100%;position: relative;display:flex;">
                <div style="width:calc( 100% - 3vh );">
                  <p style="width:100%;height:3vh;" v-for="(item,index) in scope.row.nodeList" :key="index">{{item.completeTime}}
                    <i class="el-icon-edit" style="font-size:2vh;color:#E6A23C;cursor: pointer;" @click="modNode(item)"></i>
                  </p>
                </div>
                <i class="el-icon-circle-plus" v-if="scope.row.planId &&scope.row.planId!='' " style="font-size:3vh;color:#409EFF;" @click="addNode(scope.row)"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
              <template slot-scope="scope">
                <span
                  class="el-tag el-tag--info el-tag--mini"
                  style="cursor: pointer;margin-right: 10px;"
                  @click="pwdChange(scope.row,scope.$index,true)"
                >{{scope.row.isSet?'保存':"修改"}}</span>
                <!-- <span
                  @click="delChange(scope.row,scope.$index,true)"
                  v-if="!scope.row.isSet"
                  class="el-tag el-tag--danger el-tag--mini"
                  style="cursor: pointer;"
                >删除</span> -->
                <span
                  v-if="scope.row.isSet"
                  class="el-tag el-tag--mini"
                  style="cursor: pointer;"
                  @click="pwdChange(scope.row,scope.$index,false)"
                >取消</span>
              </template>
            </el-table-column>
        </el-table>
        <!-- v-if="totalValue_view" -->
        <!-- <div v-if="totalValue_view" style="width:100%;height:5vh;display: flex;padding: 0 1vw;align-items: center;">
          <img src="../../assets/image/coladd.png" @click="addQin" style="width:3vh;height:3vh;cursor: pointer;" />
        </div> -->
        <!-- <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[3, 5, 10, 20]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalItems"
        ></el-pagination> -->
      </div>
    </div>
    <!-- 新增窗口 -->
    <el-dialog
        title="关键节点"
        :visible.sync="addFormVisible"
        center
        :append-to-body="true"
        :lock-scroll="false"
        class="add-form"
        width="400px"
    >
        <el-form
        :model="addForm"
        ref="addForm"
        label-width="100px"
        :label-position="labelPosition"
        >
          <el-form-item label="选择节点：">
            <el-cascader
              v-model="nodeVal"
              :options="nodeOpts"
              :props="props"
              collapse-tags
              clearable>
            </el-cascader>
          </el-form-item>
          <el-form-item label="开始日期：">
            <el-date-picker
              v-model="addForm.startTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="完成日期：">
            <el-date-picker
              v-model="addForm.completeTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="addFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="sumbitAddRow()">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
  data() {
    return {
      listData: [],
      groupId: '',
      nodeOpts:[],//级联列表
      props: { value: 'id',label:'nodeTypeName',children:'childList' },//级联
      // uploadUrl: myHttp.importExcelEPM, //上传地址
      // uploadHead: {
      //   accessToken: this.$store.state.token,
      // },
      // uploadData: {
      //   entProjectId: '',
      //   attachmentTypeId: '',
      //   userId: util.session.get('user').id,
      // },
      // uploadUrl1: base.url + '/upload/uploadPhoto', //上传付款评依地址
      // currentPage: 1,
      // pageSize: 10,
      // totalItems: 0,
      dataText: '数据加载中...',
      // entProjectId: '',
      // attachmentTypeId: '',
      master: {
        planId:'',
        projectId:'',
        entId:'',
        months: '', //年月
        completePercentage: '',//占比
        totalId: '',//总产值id
        monthPay:'',//产值
      },
      totalId:'',
      isAddFlag: false,
      // proType:[],
      // type:'',
      // chooseDate: util.myTime.getCurTime(),
      // projectId:'',
      projectName:'',
      name:'',
      year:'',// 年
      getTime: '', //当前
      // joinType:'2',
      projects:[],
      searchPro:[], //搜索的
      total:2000,
      isTotal:true,
      entId:'',
      totalValue_view:'',
      nodeVal:[], //节点列表
      //弹出框
      addFormVisible:false,
      addForm:{
        planId:'',
        parentNodeId:'',
        childNoteId:'',
        completeTime:'',
        startTime:''
      },
      labelPosition:'right',
      minPer:0,  //进度最小值
      // maxPer:100,  //进度最大值
      nodeEntId:'',//节点获取所需建设企业id
      info:{allDay:'0',progress:0,setmentProgress:0},
    }
  },
  mounted() {
    this.groupId = this.$store.state.groupId
    if ('' == this.groupId) {
      this.$store.commit('setGroupId')
      this.groupId = this.$store.state.groupId
    }
     this.getMoney()
    //  this.getNodeType()
    this.getJsEnt()
    this.getProgress()
  },
  methods: {
    doFilter() {
      this.getData()
    },
    //点击过滤
    showProjectFun(index) {
      this.search.unit = index
      this.getData()
    },
    //获取数据
    getData() {
      var that = this
      myHttp.projectSettlementPlanList({
        projectId:this.groupId,
        pageSize:this.pageSize,
        pageNum:this.currentPage
      }).then(function (resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.projectSettlementPlanList.list || []
            for (var i = 0; i < list.length; i++) {
               list[i].index = (i + 1) //(that.currentPage - 1) * that.pageSize + 
               list[i].isSet = false
               list[i].minPer = i==(list.length-1)?0:parseFloat(list[i+1].completePercentage)
               if(that.minPer < parseFloat(list[i].completePercentage)){
                 that.minPer = parseFloat(list[i].completePercentage)
               }
            }
            that.listData = list
            if (that.listData.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.dataText = '暂无数据'
          }
      })
    },

    //获取列表最大时间
    getMonthMax(){
      var result = ''
      if(this.listData.length>0){
        var max = ''
        for(var i=0;i<this.listData.length;i++){
          if(max==''){
            max = this.listData[i].months
          }else{
            if(new Date(max).getTime()<new Date(this.listData[i].months).getTime()){
              max = this.listData[i].months
            }
          }
        }
        var month = new Date(max).getMonth()
        var date = new Date(max).setMonth(month + 1)
        result = util.myTime.getCurMonth(date)
      }
      return result;
    },

    //添加
    addQin() {
      if (this.isAddFlag) {
        this.$message.warning('请先保存当前台账')
        return
      } else if (this.master.planId != '') {
        this.$message.warning('请先保存当前编辑项')
        return
      }
      this.isAddFlag = true
      this.master = {
        index:this.listData.length+1,
        planId:'',
        projectId:'',
        entId:'',
        months: '', //年月
        completePercentage: '',//占比
        monthPay:'',//产值
        isSet: true,
        totalId:'',
        minPer:this.minPer
      }
      this.master.months =  this.getMonthMax()
      this.listData.unshift(this.master)
      console.log(this.listData);
    },

    //修改
    pwdChange(row, index, cg) {
      //点击修改 判断是否已经保存所有操作
      var that = this
      //for (let i of this.master) {
      if (
        (this.master.planId != '' &&
          this.master.planId != row.planId) ||
        (this.isAddFlag && cg && !row.isSet)
      ) {
        this.$message.warning('请先保存当前编辑项')
        return false
      }
      //}
      //是否是取消操作
      if (!cg) {
        //if (!app.master_user.sel.id) app.master_user.data.splice(index, 1);
        this.getData()
        this.master = {
          planId:'',
          projectId:'',
          entId:'',
          months: '', //年月
          completePercentage: '',//占比
          monthPay:'',//产值
          isSet: true,
          totalId:'',
        }
        this.isAddFlag = false
        return (row.isSet = !row.isSet)
      }
      //提交数据
      if (row.isSet) {
        //项目请求操作
        var that = this
        // this.master.entId = this.entId
        console.log(this.nodeEntId);
        this.master.entId = this.nodeEntId
        console.log(this.master);
        this.master.projectId = this.groupId
        this.master.totalId = this.totalId
        if (this.master.planId == '') {
          myHttp.addPlanProgress(this.master).then(function (resp) {
            if (resp.data.code == '200') {
              that.$message.success('添加成功')
              that.minPer = parseFloat(that.master.completePercentage)
              that.isAddFlag = false
              that.getData()
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        } else {
          myHttp.editPlanProgress(this.master).then(function(resp){
            if (resp.data.code == '200') {
              that.$message.success('保存成功')
              that.getData()
              that.isAddFlag = false
              that.master = {
                planId:'',
                projectId:'',
                entId:'',
                months: '', //年月
                completePercentage: '',//占比
                monthPay:'',//产值
                isSet: true,
                totalId:''
              }
            } else {
              that.$message.error(resp.data.msg)
            }
          })
        }
      } else {
        this.master = {
          planId: row.planId,
          months: row.months,
          projectId: row.projectId,
          completePercentage: row.completePercentage,
          monthPay:row.monthPay
        }
        row.isSet = true
      }
    },
    // 施工进度
    getProgress(){
      var that =this
      // projectContractDuration
      myHttp.projectContractDuration({
        projectId: this.groupId,
      }).then(function (resp) {
        if (resp.data.code == '200') {
          var  info = resp.data.data
          // 施工进度
          var now = util.myTime.getCurTime()
          info.restDay = util.myTime.getdayByDate(info.startDate,now)
          if (info.allDay == 0) {
              info.progress = 0
            }else {
              var progress = ((parseInt(info.restDay) /parseInt(info.allDay)) * 100 ).toFixed(2)
              info.progress =progress>100?100:progress
            }
               // 计划产值进度
        if(that.totalValue_view==0||info.checkSettlement==0){
          info.setmentProgress = 0
        }else{
          var setmentProgress = ((parseInt(info.checkSettlement) /parseInt(that.totalValue_view)) * 100 ).toFixed(2)
          info.setmentProgress =setmentProgress>100?100:setmentProgress
        }
             that.info =info
        }
      
      })
    },
    // 删除
    delChange(row, index, cg) {
      var that = this
      //for (let i of this.master) {
      if (
        (this.master.planId != '' &&
          this.master.planId != row.planId) ||
        (this.isAddFlag && cg && !row.isSet)
      ) {
        this.$message.warning('请先保存当前编辑项')
        return false
      }
      this.$confirm('此操作将删除该调数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          myHttp.deleteProjectSettlementPlan({
              planId: row.planId,
          }).then(function (resp) {
              if (resp.data.code == '200') {
                that.$message.success('删除成功')
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
        }).catch((err) => {})
    },
    // addFun(){
    //     var token = this.$store.state.token
    //     var entId = this.groupId
    //     var projectName  = this.projectName 
    //     var projectId = this.projectId
    //     var month = this.month
    //     window.open(
    //       myHttp.exportProjectSettlementList +
    //         '?entId=' +
    //         entId +
    //         '&projectName=' +
    //         projectName +
    //         '&month=' +
    //         month +
    //         '&projectId=' +
    //         projectId +
    //         '&accessToken=' +
    //         token
    //     )
    // },
    // 总产值回显
    getMoney(){
      var that = this
      myHttp.totalInformation({
        projectId: this.groupId,
      }).then(function (resp) {
        if (resp.data.code == '200') {
          if(resp.data.data){
              that.totalValue_view = resp.data.data.totalValue
              that.totalId = resp.data.data.totalId
              that.entId = resp.data.data.entId
              that.getData()
          }else{
            that.totalValue_view =''
            that.totalId = ''
            that.dataText="暂无数据"
          }
          
        }
      })
    },
    getValue(e){
      this.master.monthPay = e
      // console.log(this.master.monthPay)
      // console.log(e)
    },

    /**
     * 获取企业建设单位
     */
    getJsEnt(){
      var that = this
      myHttp.getJsEntByProjectId({
        projectId:this.groupId
      }).then(function(resp){
        console.log(resp);
        //
        if(resp.data.code=='200'){
          var data = resp.data.data.projectEnt
          if(data){
            that.nodeEntId = data.entId
            console.log(data.entId);
            that.getNodeType()
          }
        }
      })
    },

    /**
    * 施工节点
    */
    getNodeType(){
      var that = this
      console.log(this.nodeEntId);
      myHttp.sysNodeList({
        nodeType:'1',
        entId:this.nodeEntId
      }).then(function(resp){
        if (resp.data.code == '200') {
          var list = resp.data.data.list || []
          for(var i=0;i<list.length;i++){
            if(list[i].childList && list[i].childList.length==0){
              delete list[i].childList
            }
          }
          that.nodeOpts =list
        }
        // console.log(resp)
      })
    },
     /**
      * 根据占比获取数据
      */
     proportionFun(row){
       var mix = parseFloat(this.master.completePercentage)/100;
       var val = (parseFloat(this.totalValue_view)*mix).toFixed(2)
       this.master.monthPay = val
       row.monthPay = val
     },
     /**
      * 添加节点弹出框
      */
     addNode(row){
       this.addFormVisible = true
       this.addForm.planId = row.planId
       this.addForm.projectNodeId = ''
       this.addForm.parentNodeId = ''
       this.addForm.childNoteId = ''
       this.addForm.completeTime = row.months+'-01'
       this.addForm.startTime = row.months+'-01'
       this.nodeVal = []
     },
     //提交节点
     sumbitAddRow(){
        if(this.nodeVal.length==0){
         this.$message.error('请选择关键节点')
         return
        }
        if(this.addForm.completeTime==''||this.addForm.startTime==''){
         this.$message.error('请选择开始/完成时间')
         return
        }
        var that = this
        if(this.nodeVal.length==1){
          this.addForm.parentNodeId = '0'
          this.addForm.childNoteId = this.nodeVal[0]
        }else if(this.nodeVal.length==2){
          this.addForm.parentNodeId = this.nodeVal[0]
          this.addForm.childNoteId = this.nodeVal[1]
        }
        if(this.addForm.projectNodeId && this.addForm.projectNodeId!=''){
          myHttp.editKeyNodes(this.addForm).then(function(resp){
            if(resp.data.code=='200'){
              that.addFormVisible = false
              that.$message.success('添加成功')
              that.getData()
            }else{
              that.$message.error(resp.data.msg)
            }
          })
        }else{
          myHttp.addKeyNodes(this.addForm).then(function(resp){
            if(resp.data.code=='200'){
              that.addFormVisible = false
              that.$message.success('添加成功')
              that.getData()
            }else{
              that.$message.error(resp.data.msg)
            }
          })
        }
     },

     //判断月份
     checkMonth(){
       var val = this.master.months
       var result = false
       for(var i=1;i<this.listData.length;i++){
         if(new Date(val)<new Date(this.listData[i].months)){
           result = true
         }
       }
       if(result){
         this.$message.error('选择月份不能小于当前已经填写的月份！')
       }
     },

     /** 
      * 修改关键节点
     */
    modNode(item){
      console.log(item)
       this.addFormVisible = true
       this.addForm.planId = item.planId
       this.addForm.projectNodeId = item.projectNodeId
       this.addForm.parentNodeId = ''
       this.addForm.childNoteId = ''
       this.addForm.startTime = item.startTime
       this.addForm.completeTime = item.completeTime
       if(item.parentNodeId=='0'){
         this.nodeVal = [item.sysNodeId]
       }else{
          this.nodeVal = [item.parentNodeId,item.sysNodeId]
       }
    },

  },
}
</script>
<style scoped>
.header-box {
  padding: 15px 20px;
  height: 70px;
  width: 100%;
  box-shadow: 1px 2px 3px 2px #ddd;
  background: #fff;
  box-sizing: border-box;
  position: relative;
  text-align: left;
}
.box {
  width: 100%;
  height: 100%;
}
.box-content {
  width: 100%;
  height: calc(100% - 10vh);
  background: #fff;
}
.box-content-item {
  width: 100%;
  background: #fff;
  min-height: 200px;
  margin-top: 6px;
  display: flex;
  align-content: center;
  align-items: center;
  box-sizing: border-box;
}
.box-content-item .cell {
  width: 33%;
  padding-left: 50px;
  text-align: left;
}
.box-content-item .row {
  width: 100%;
}
.box-content-item .row .warning {
  color: red;
}
.wrap {
  display: flex;
  flex-wrap: wrap;
}
.build-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 6vh;
  background: #fff;
  border-bottom: 3px solid #f5f5f5;
  padding: 0 20px;
}
/* 字体颜色 */
.font-color1 {
  color: #ffbc01;
}
.font-color2 {
  color: #0085ff;
}
.upload-demo {
  margin: 0 20px;
}
</style>
<style>
.build-bar span {
  margin-left: 0;
}
.el-table td,
.el-table th {
  text-align: center;
}
.el-pagination {
  background: #fff;
  padding: 15px 0;
}
.build-bar > .el-button--success {
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
}
.el-image .el-icon-circle-close {
  color: #fff;
}
/* .wageLedger .el-button {
  color: #fff;
  background: #1890ff;
} */
</style>
<style>
  @import '../../assets/css/common.css'
</style>